export default {

    LOAD_USERS(state,users){
        state.items = users;
    }


}